import { render, staticRenderFns } from "./column_management.vue?vue&type=template&id=27e7394e&scoped=true&"
import script from "./column_management.vue?vue&type=script&lang=js&"
export * from "./column_management.vue?vue&type=script&lang=js&"
import style0 from "./column_management.vue?vue&type=style&index=0&id=27e7394e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e7394e",
  null
  
)

export default component.exports